import React, { useState } from 'react';
import { Tree } from 'antd';
import {
  ButtonContainer,
  SubmitButton,
  StyledLabel,
} from '../../../../common/form/FormElements.jsx';
import PropTypes from 'prop-types';

import { ImageRenderer, CollapseBlock } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';
import useOnTreeDrop from '../../../../../hooks/useOnTreeDrop.jsx';

const addKeyToSlider = (sliders) => {
  const sliderWithKey = [];

  sliders.map((slider) => sliderWithKey.push({ key: slider.id, ...slider }));
  sliderWithKey.sort((a, b) => (a.position < b.position ? -1 : 1));
  return sliderWithKey;
};

const SliderSortOrderTree = ({ sliders, onOrderSave }) => {
  const [orderedSliders, setOrderedSliders] = useState(
    addKeyToSlider(sliders || []),
  );

  const { t } = useTranslation();

  const onDrop = useOnTreeDrop(orderedSliders, (data) => {
    //Returned data items are in order -> update only position
    const newData = data.map((item, index) => ({
      ...item,
      position: index + 1,
    }));

    setOrderedSliders(newData);
  });

  return (
    <div style={{ margin: '10px' }}>
      <CollapseBlock>
        <StyledLabel>{t('Poradie banerov')}</StyledLabel>
        <Tree
          className="draggable-tree"
          draggable
          blockNode
          onDrop={onDrop}
          treeData={orderedSliders}
          allowDrop={({ dropPosition }) => dropPosition > 0} // * - Disabled nesting
          titleRender={(node) => (
            <ImageRenderer
              source={node.image}
              id={node.id}
              description={node.meta_name}
            />
          )}
        />
      </CollapseBlock>
      <ButtonContainer>
        <SubmitButton
          submitKey={'sliders'}
          onClick={() => onOrderSave(orderedSliders)}
          type="button"
        >
          {t('Uložiť')}
        </SubmitButton>
      </ButtonContainer>
    </div>
  );
};

SliderSortOrderTree.propTypes = {
  sliders: PropTypes.array,
  onOrderSave: PropTypes.func,
};

export default SliderSortOrderTree;
